import en from './en';
import de from './de';
import es from './es';
import id from './id';
import tr from './tr';
import zh from './zh';

export default {
  en,
  de,
  es,
  id,
  tr,
  zh,
};
